const initState = {
  LaodingMass: false,
  mobileOverlayState: false,
  adminDevicePage: false,
  cameraPermissionGranted: false,
  guestLoginPage: false,
  fbStatus: false,
  callFacebookPopup: false,
  facebookProfile: null,
  faceData: {},
  guestInRoom: true,
  notInHotelPopup: false,
  shouldShowCustomPopup:false,
  customPopupConfigs:{},
  popupMsg: "",
  sessionToken: null,
  reservationNo: null,
  confromPage: false,
  conformMessage: null,
  compName: null,
  CheckedInGuest: [],
  TintControlData: [],
  selectedWindows: [],
  selectedTintLevel: 1,
  currentWindow: null,
  guestCheckedOut: true,
  installedAppVersion: null,
  installedAppBuildNo: null,
  installedAppName: null,
  installedAndroidSDKVersion: null,
  installedAppPackageName: null,
  guestDocOptions: [],
  preloadScreen: false,
  QRScannerPage: false,
  showChatBubble: false,
  freshChatData: null,
  layoutType: '',
  acSelected: false,
  showGuestLogin: false,
  showLoginRequired: false,
  customTextForLoginPopup:{},
  loginRequiredMessage: "",
  //Inncom room control
  tVLiftList: [],
  showTVLiftWidget: true,
leaSpeakerData: {},
selectedMasterDevice: null,
speakerInZone: {}
,
  lightScene: [],
  curtain: [],
  DND: null,
  MUR: null,
  showDisableOrderPopup: true,

  currentTintWindow: "",
  currentZoneStep: 1,
  //--------------
  hvac: [],
  minimumChannelWatchDuration: 0,
  survey: {},
  sideNavBar: {
    navItems: [],
    logoClick: false,
    currentWidget: {}
  },
  appLauncher: {
    widget: [],
    packageApp: "com.facebook.katana",
    urlScheme: "Crestron://"
  },
  deviceReg: {
    CorrectIP: false,
    connectorIP: null,
    locations: [],
    conformationPage: false,
    guestRegPag: false,
    deviceName: null,
  },
  home: {
    clientConfig: {},
    screenInfoAfterLoader: {},
    currentDuration: { brandingInfo: '' },
    serverTimeDate: {},
    weatherInfo: {},
    isMobileTV: false,
    latestAppData: null,
    languageList: [],
    languageCodeList: [],
    languagelistData: [],
    latestCssData: null,
    currentCSSVersion: null,
    guestDetails: {
      locationId: 0
    },
    faqUrl: null,
    privacyPolicyUrl: null,
    tncUrl:null,
    langWidget: null,
    guestLanguage: {
      preferredLanguageCode: ""
    },
    hotelLanguages: {},
    stringConst: {},
    durationLang: "",
    MenuColor: {},
    firstTimeOnHome: 0,
    gJnotifications: [],
    guestStepsDropDownOptions: []
  },
  activity: {
    activitiesData: {},
    currentActivity: {},
    nextActivity: {},
    signUpactivities: []
  },
  music: {
    musicList: [],
    musicGenres: {
      genres: {

      }
    },
    currentPlaylist: null,
    goToCurrentPlaylist: false,
    isLoading:false,
    musicConfig: {
      shuffle: false,
      repeatOne: false,
    },
    currentSong:null,
    isPlayingInBackground:false
  },
  movies: {
    videoPlayer: false,
    videoPath: false,
    videoList: []
  },
  tvChannels: {
    channelData: [],
    languageGrouping:{},
    categoryGrouping:{},
    currentChannel: {},
    roomRemoteDetails: [],
    currentTv: {},
    nextTV: {},
    conformPage: false,
    TVType: null
  },
  guestRequest: {
    CheckedInGuest: [],
    guestRequestList: {},
    showGuestRequestSubmitPage: false,
    guestRequestOtherData: {},
    groupedGuestRequestData:[],
    requestIDList: []
  },
  //---------------------------Room Control--------------------------------------
  roomControl: {
    VDAResponse: {},
    VDAZoneList: [],
    selectedZone: {},
    seletedIndex: null,
    zoneCount: 0,
    selectedControlZone: {},
    //-------------------old store------------
    // speaker control 
    currentControl: {},
    speakerSource: {},
    speakerList: [],
    currentSongSource: null,
    selectedSpeaker: null,
    speakerZone: null,
    //AC controls
    powerSwitch: null,
    ecoMode: null,
    ACControlStatus: {
      currentACTemp: 999
    },
    currentLightscene: null,
    currentFanSpeed: null,
    lightScreens: [],
    celciusMin: null,
    celciusMax: null,
    doNotDisturb: null,
    makeUpRoom: null,
    currentRoomTemp: 999,
    //Curtain cantrol
    currentCurtain: null,
    curatinList: [],
    RoomControlStatus: {
      zone: {
      }
    }
  },
  InncomRoomControl: {
    configs: [],
    lightScene: [],
    curtain: [],
    DND: null,
    MUR: null,
    hvac: [],
    selectedAC: {},
    selectedIndex: null,
    currentRoomTemp: null,
    currentFanSpeed: null,
    currentAcTemp: null,
    powerSwitch: 'ON',
    celciusMin: 0,
    celciusMax: 100,
    farenheitMax: 0,
    farenheitMin: 212,
    acMode: null
  },
  VDARoomControl: {
    RoomControlData: {},
    configs: [],
    lightScene: [],
    DND: null,
    MUR: null,
    hvac: [],
    selectedAC: {},
    selectedIndex: null,
    currentRoomTemp: null,
    currentFanSpeed: null,
    currentAcTemp: null,
    zoneId: null,
    celciusMin: 0,
    celciusMax: 100,
    farenheitMax: 0,
    farenheitMin: 212,
    acMode: null
  },
  RoomControlZonesWiseData: {
    rooms:[],
    fanSpeedConfig:[]
  },
  roomAssistance: {
    popupStatus: false
  },
  browserListPopup: {
    browserList: [],
    showPopup: false
  },
  vod: {
    VODData: null,
    pageNumber: 1,
    genre: {
      currentGenrePage: 0
    },
    lang: {
      currentLang: null,
      callFromLang: false,
      currentLangIndex: 0
    },
    previousMovie: null,
    currentMovie: null,
    nextMovie: null,
    movieList: []
  },
  spa: {
    currentPage: "mainMenu",
    subTitle: null,
    itemTitle: null
  },
  showWarningPopup: {
    show: false,
    msg: ""
  },
  //--------------------------H-Commerce---------------------------------------
  Hcommerce: {
    currentPage: "StoreItemTypeList",
    StoreItemType: {},
    SelectedSubItem: null,
    SelectedFood: null,
    SelectedNavComponent: null,
    storeItemTypeSubTypeInfo: null,
    itemTypeList: [],
    groupedStoreItemTypeList: [],
    itemSubTypeList: [],
    itemAddOnsInfo: [],
    addOnGroupTypeItemAddonInfo: [],
    storeItemAddOnGroupInfo: [],
    addOnGroupTypeInfo: [],
    storeItemList: [],
    upsellItem: [],
    deliveryLocations: [],
    storeItemStoreUpsellItemInfo: [],
    storeItemStoreItemSubTypeInfo: [],
    storeItemStoreItemTypeInfo: [],
    storeInfo:[],
    subItemList: [],
    subItemListStoreLevel2: [],
    subTypeSubTypeMapping: [],
    selectedStoreItemList: [],
    selectedStoreSubMenuList: [],
    selectedSubtypeSubMenuList: [],
    selectedSubItemStoreLevel2: null,
    orderDetailPage: false,
    orderDetail: {},
    totalPrice: 0,
    selectedLocation:null,
    hCommerceSavedOrders:[],
    isPricingViaToast: false
  },
  viewBill: {
    billItems: []
  },
  failScreenconfig: {
    showFailScreen: false,
    failScreenMessage1: "",
    failScreenMessage2: "",
    showClose: true
  },
  logout: {
    status: false
  },
  
  //-----------------------------View Bill------------------------------
  viewBill: {
    billItems: [],
    billTotal: null,
    billForGuest: false,
    extendStayID: null
  },
  //---------------------------Door Ker------------------------
  doorKey: {
    showDoorKeyPage: false,
    doorLogin: false,
    runNativeCalls: false,
    errorPopUP: false,
    rescan: false
  },

  //---------------------------guest journey notification------------------------

}

export default (state = initState, action) => {
  switch (action.type) {
    case 'Set_Video_PLayer':
      return {
        ...state, movies: {
          ...state.movies,
          videoPlayer: action.payload.status,
          videoPath: action.payload.path
        }
      }
    case 'Set_Face_Data':
      return {
        ...state, faceData: action.payload
      }
    case 'Set_Installed_App_Version':
      return {
        ...state, installedAppVersion: action.payload
      }
    case 'Set_Installed_App_Build_No':
      return {
        ...state, installedAppBuildNo: action.payload
      }
    case 'Set_App_Name':
      return {
        ...state, installedAppName: action.payload
      }
    case 'Set_Installed_Android_SDK_Version':
      return{
        ...state, installedAndroidSDKVersion: action.payload
      }
    case 'Set_App_Package_Name':
      return {
        ...state, installedAppPackageName: action.payload
      }
    case 'Set_Facebook_Profile':
      return {
        ...state, facebookProfile: action.payload
      }
    case 'Set_Facebook_Popup':
      return {
        ...state, callFacebookPopup: action.payload
      }
    case 'Fetch_Music_Data':
      return {
        ...state, music: {
          ...state.music,
          musicData: action.payload.music
        }
      }
    case 'Fetch_Channels_Data':
      return {
        ...state, tvChannels: {
          ...state.tvChannels,
          channelData: action.payload.channelData,
          languageGrouping:action.payload.languageGrouping,
          categoryGrouping:action.payload.categoryGrouping,
          currentChannel: action.payload.currentChannel
        }
      }
    case 'Set_Channel_Data':
      return{
        ...state, tvChannels: {
          ...state.tvChannels, 
          channelData: action.payload
        }
      }
    case 'Current_Channels_Data':
      return {
        ...state, tvChannels: {
          ...state.tvChannels,
          currentChannel: action.payload
        }
      }
    case 'Room_Assistance_Status':
      return {
        ...state, roomAssistance: {
          popupStatus: action.payload
        }
      }
    case 'Guest_Language':
      // console.log("guest language", action.payload)
      return {
        ...state, home: {
          ...state.home,
          guestLanguage: action.payload
        }
      }
    case 'Client_Side_Config_Data':
      //console.log("client config", action.payload)
      return {
        ...state, home: {
          ...state.home,
          clientConfig: action.payload
        }
      }
    case "Screen_Info_After_Loader":
      return {
        ...state, home: {
          ...state.home,
          screenInfoAfterLoader: action.payload
        }
      }
    case 'Set_Language_list':
      //console.log("client config", action.payload)
      return {
        ...state, home: {
          ...state.home,
          languageList: action.payload
        }
      }
    case 'Set_Language_list_Data':
      //console.log("client config", action.payload)
      return {
        ...state, home: {
          ...state.home,
          languagelistData: action.payload
        }
      }
    case 'Set_Language_Codes':
      //console.log("client config", action.payload)
      return {
        ...state, home: {
          ...state.home,
          languageCodeList: action.payload
        }
      }
    case 'Update_Current_Duration':

      const { brandingInfo = {} } = action.payload.currentDuration || {};

      const logoUrl = brandingInfo.hotelLogoImageUrl || '';
      sessionStorage.setItem("brandLogo", logoUrl);
      
      return {
        ...state, home: {
          ...state.home,
          currentDuration: action.payload.currentDuration,
          durationLang: action.payload.durationLang,
          stringConst: action.payload.stringConst
        }
      }

    case 'Set_default_Lang':
      return {
        ...state, home: {
          ...state.home,
          stringConst: action.payload
        }
      }

    case 'Get_Server_Time':
      return {
        ...state, home: {
          ...state.home,
          serverTimeDate: action.payload,
        }
      }
    case 'Weather_Data':
      return {
        ...state, home: {
          ...state.home,
          weatherInfo: action.payload,
        }
      }
    case 'Guest_Details':
      return {
        ...state, home: {
          ...state.home,
          guestDetails: action.payload.guestDetails
        },
        reservationNo: action.payload.reservationNo
      }
    case 'Update_Guest_Lang':
      return {
        ...state, home: {
          ...state.home,
          guestLanguage: {
            preferredLanguageCode: action.payload.lang,
          },
          durationLang: action.payload.lang
        }
      }
    
      case 'Hotel_language':
      return {
        ...state, home: {
          ...state.home,
          hotelLanguages: action.payload
        }
      }

    case 'Set_guest_steps_dropdown_options':
      return {
        ...state, home: {
          ...state.home,
          guestStepsDropDownOptions: action.payload
        }
      }
    case 'Set_Latest_App_Data':
      return {
        ...state, home: {
          ...state.home,
          latestAppData: action.payload
        }
      }
    case 'Set_Layout_CSS_Data':
      return {
        ...state, home: {
          ...state.home,
          latestCssData: action.payload
        }
      }
    case 'setLogout':
      console.log("logout reducer called")
      return {
        ...state, fbStatus: action.payload
      }
    case 'Set_Activities':
      //console.log("reducer act",action.payload);

      return {
        ...state, activity: {
          ...state.activity,
          activitiesData: action.payload,
          currentActivity: action.payload.activityMaster[0]
        }
      }
    case 'Set_Current_Activity':
      if (action.payload.nextActivity) {
        return {
          ...state, activity: {
            ...state.activity,
            currentActivity: action.payload.currentActivity,
            nextActivity: action.payload.nextActivity,
          }
        }
      } else {
        return {
          ...state, activity: {
            ...state.activity,
            currentActivity: action.payload.currentActivity,
          }
        }
      }
    case 'Set_Nav_Item':
      return {
        ...state, sideNavBar: {
          ...state.sideNavBar,
          navItems: action.payload
        }
      }
    case 'Click_On_Logo':
      return {
        ...state, sideNavBar: {
          ...state.sideNavBar,
          logoClick: action.payload
        }
      }
    case 'Set_signUp_Activities':
      return {
        ...state, activity: {
          ...state.activity,
          signUpactivities: action.payload
        }
      }
    case 'Add_To_SignUp_Activities':
      let tempList = state.activity.signUpactivities;
      //console.log("tempList", tempList)
      tempList.push(action.payload);
      return {
        ...state, activity: {
          ...state.activity,
          signUpactivities: tempList
        }
      }
    case 'Browsers_List':
      return {
        ...state, browserListPopup: {
          ...state.browserListPopup,
          browserList: action.payload.browserList,
          showPopup: action.payload.showPopup
        }
      }
    case 'Show_Browsers_Popup':
      return {
        ...state, browserListPopup: {
          ...state.browserListPopup,
          showPopup: action.payload
        }
      }
    case 'Update_Duration_Lang':
      return {
        ...state, home: {
          ...state.home,
          durationLang: action.payload
        }
      }
    case 'Set_FAQ_Url':
      return {
        ...state, home: {
          ...state.home,
          faqUrl: action.payload
        }
      }    
    case 'Set_PrivacyPolicy_Url':
      return {
        ...state, home: {
          ...state.home,
          privacyPolicyUrl: action.payload
      }
    }
    case 'Set_Ac_Selected':
      return {
        ...state, acSelected: action.payload
      }    
    case 'Set_TnC_Url':
      return {
        ...state, home: {
          ...state.home,
          tncUrl: action.payload
        }
      } 
    case 'add_Lang_Widget':
      return {
        ...state, home: {
          ...state.home,
          langWidget: action.payload
        }
      }
    case 'Set_Custom_CSS_Path':
      return {
        ...state, home: {
          ...state.home,
          customCSSFile: action.payload
        }
      }   

    case 'Set_Mobile_TV_Page':
      return {
        ...state, home: {
        ...state.home,
        isMobileTV: action.payload
        }
      }
    case 'Update_Page_Number':
      return {
        ...state, vod: {
          ...state.vod,
          pageNumber: action.payload
        }
      }
    case 'Update_Genre_Page_Number':
      return {
        ...state, vod: {
          ...state.vod,
          genre: {
            currentGenrePage: action.payload
          }
        }
      }
    case 'Update_Lang_Page':
      return {
        ...state, vod: {
          ...state.vod,
          lang: {
            currentLang: action.payload.lang,
            callFromLang: action.payload.callFromLang,
            currentLangIndex: action.payload.indexOfLang
          }
        }
      }
    case 'Fetch_VOD_Data':
      return {
        ...state, vod: {
          ...state.vod,
          VODData: action.payload
        }
      }
    case 'Update_Current_Movie':
      return {
        ...state, vod: {
          ...state.vod,
          currentMovie: action.payload
        }
      }
    case 'Update_Previous_Movie':
      return {
        ...state, vod: {
          ...state.vod,
          previousMovie: action.payload
        }
      }
    case 'Update_Next_Movie':
      return {
        ...state, vod: {
          ...state.vod,
          nextMovie: action.payload
        }
      }
    case 'Update_Movie_List':
      return {
        ...state, vod: {
          ...state.vod,
          movieList: action.payload
        }
      }
    case 'Room_Remote_Details':
      return {
        ...state, tvChannels: {
          ...state.tvChannels,
          roomRemoteDetails: action.payload
        }
      }
    case 'Set_TV_Token':
      return {
        ...state, tvChannels: {
          ...state.tvChannels,
          tvToken: action.payload
        }
      }
    case 'Set_Current_TV':
      return {
        ...state, tvChannels: {
          ...state.tvChannels,
          currentTv: action.payload
        }
      }
    case 'Set_Next_TV':
      return {
        ...state, tvChannels: {
          ...state.tvChannels,
          nextTV: action.payload
        }
      }
    case 'Set_TV_Type':
      return {
        ...state, tvChannels: {
          ...state.tvChannels,
          TVType: action.payload
        }
      }
    case 'In_Hotel_Popup':
      return {
        ...state,
        notInHotelPopup: action.payload.status,
        popupMsg: action.payload.errorMsg
      }
    case "SHOW_CUSTOM_POPUP":
      return  {
        ...state,
        shouldShowCustomPopup:action.payload.status,
        customPopupConfigs:action.payload.configs
        }
    case 'FB_Logout_Popup':
      return {
        ...state, logout: {
          ...state.logout,
          status: action.payload
        }
      }
    case 'Movie_List':
      return {
        ...state, movies: {
          ...state.movies,
          videoList: action.payload
        }
      }
    case 'Music_Genre_List':
      return {
        ...state, music: {
          ...state.music,
          musicGenres: action.payload,
          isLoading:false
        }
      }
    case 'Music_Genre_List_SET_LOADING':
        return {
          ...state, music: {
            ...state.music,
            isLoading: action.payload
          }
        }
      case "Set_Music_Config":
        return {
          ...state, music: {
            ...state.music,
            musicConfig: {
              ...state.music.musicConfig,
              ...action.payload
            }
          }
        }
      case 'Music_Set_Current_Song':
        return {
          ...state, music: {
            ...state.music,
            currentSong: action.payload
          }
        }
      case 'Music_Set_Background_Play':
        return {
          ...state, music: {
            ...state.music,
            isPlayingInBackground: action.payload
          }
        }
    case 'Session_Token':
      return {
        ...state, sessionToken: action.payload
      }
    case 'Set_Loading_Mass':
      return {
        ...state, LaodingMass: action.payload
      }
    case 'Set_Playlist':
      return {
        ...state, music: {
          ...state.music,
          currentPlaylist: action.payload
        }
      }
    case "Go_To_Current_Playlist": {
      return {
        ...state, music: {
          ...state.music,
          goToCurrentPlaylist: action.payload
        }
      }
    }
    case 'Music_List':
      return {
        ...state, music: {
          ...state.music,
          musicList: action.payload,
          isLoading:false
        }
      }
    case 'Set_Admin_Page':
      return {
        ...state, adminDevicePage: action.payload
      }
    case 'Room_Selector_Status':
      return {
        ...state, deviceReg: {
          ...state.deviceReg,
          CorrectIP: action.payload
        }
      }
    case 'Room_List':
      return {
        ...state, deviceReg: {
          ...state.deviceReg,
          locations: action.payload.locations
        }
      }
    case 'Set_Connector_IP':
      return {
        ...state, deviceReg: {
          ...state.deviceReg,
          connectorIP: action.payload
        }
      }
    case 'Set_Conformation_Page':
      return {
        ...state, deviceReg: {
          ...state.deviceReg,
          conformationPage: action.payload
        }
      }
    case 'Set_App_launcher_widget':
      return {
        ...state, appLauncher: {
          ...state.appLauncher,
          widget: action.payload
        }
      }
    case 'Set_Reg_Page':
      return {
        ...state, deviceReg: {
          ...state.deviceReg,
          guestRegPag: action.payload
        }
      }
    case 'Set_Device_Name':
      return {
        ...state, deviceReg: {
          ...state.deviceReg,
          deviceName: action.payload
        }
      }
    case 'Menu_Color':
      return {
        ...state, home: {
          ...state.home,
          MenuColor: action.payload
        }
      }
    case 'First_Time_On_Home':
      return {
        ...state, home: {
          ...state.home,
          firstTimeOnHome: action.payload
        }
      }
    case 'Spa_Page_Change':
      return {
        ...state, spa: {
          ...state.spa,
          currentPage: action.payload
        }
      }
    case 'Spa_Sub_Title_Change':
      return {
        ...state, spa: {
          ...state.spa,
          subTitle: action.payload
        }
      }
    case 'Spa_Item_Title_Change':
      return {
        ...state, spa: {
          ...state.spa,
          itemTitle: action.payload
        }
      }
    case "Set_Current_Widget":
      return {
        ...state, sideNavBar: {
          ...state.sideNavBar,
          currentWidget: action.payload
        }
      }

    case 'Check_In_Guest_List':
      return {
        ...state,
        CheckedInGuest: action.payload
      }
    //--------------------------H-Commerce---------------------------------------

    case "Set_hcommerce_Page":
      return {
        ...state, Hcommerce: {
          ...state.Hcommerce,
          currentPage: action.payload
        }
      }
    case "Set_Store_Item_Type":
      return {
        ...state, Hcommerce: {
          ...state.Hcommerce,
          StoreItemType: action.payload
        }
      }
    case "Selected_Sub_Item":
      return {
        ...state, Hcommerce: {
          ...state.Hcommerce,
          SelectedSubItem: action.payload
        }
      }
    case "Selected_Food":
      return {
        ...state, Hcommerce: {
          ...state.Hcommerce,
          SelectedFood: action.payload
        }
      }

    case "Set_Total_Order_Price":
      return {
        ...state, Hcommerce: {
          ...state.Hcommerce,
          totalPrice: action.payload
        }
      }
    
    case "Selected_NavComponent":
      return {
        ...state, Hcommerce: {
          ...state.Hcommerce,
          SelectedNavComponent: action.payload
        }
      }

    case "Set_selected_location":
      return{
        ...state, Hcommerce: {
          ...state.Hcommerce,
          selectedLocation: action.payload
        }

      }

      case "Set_hCommerce_saved_orders":
        return{
          ...state, Hcommerce: {
            ...state.Hcommerce,
            hCommerceSavedOrders: action.payload
          }
  
        }

   

    //----------------------guest request-------------------------
    // case 'Check_In_Guest_List':
    //   return {
    //     ...state, guestRequest: {
    //       ...state.guestRequest,
    //       CheckedInGuest: action.payload
    //     }
    //   }

    case 'Guest_Request_List':
      return {
        ...state, guestRequest: {
          ...state.guestRequest,
          guestRequestList: action.payload.requestMaster,
          guestRequestOtherData: action.payload.guestRequestOtherData,
          groupedGuestRequestData: action.payload.groupedGuestRequestData
        }
      }

    case 'Set_Submit_Request_Window':
      return {
        ...state, guestRequest: {
          ...state.guestRequest,
          showGuestRequestSubmitPage: action.payload
        }
      }
    case 'Set_Request_ID_List':
      return {
        ...state, guestRequest: {
          ...state.guestRequest,
          requestIDList: action.payload
        }
      }
    case 'Set_Submit_Request_Window_and_PopUP':
      return {
        ...state, guestRequest: {
          ...state.guestRequest,
          showGuestRequestSubmitPage: action.payload.submitRequestWindow
        },
        notInHotelPopup: action.payload.successPopUP,
        popupMsg: action.payload.msg
      }
    //------------------------------------------------------------  
    case "Store_Item_Type_Sub_Type_Info":
      return{
        ...state, Hcommerce: {
          ...state.Hcommerce,
          storeItemTypeSubTypeInfo: action.payload
        }
      }
    case "Item_Type_List":
      return {
        ...state, Hcommerce: {
          ...state.Hcommerce,
          itemTypeList: action.payload
        }
      }
    case "Grouped_Store_Item_Type_List":
      return {
        ...state, Hcommerce: {
          ...state.Hcommerce,
          groupedStoreItemTypeList: action.payload
        }
      }
    case "Set_Upsell_Item"://
      return {
        ...state, Hcommerce: {
          ...state.Hcommerce,
          upsellItem: action.payload
        }
      }
    case "Get_StoreInfo":
      return {
        ...state, Hcommerce: {
          ...state.Hcommerce,
          storeInfo: action.payload
        }
      }
    case "Hcommerce_Pricing_Via_Toast":
      return{
        ...state, Hcommerce: {
          ...state.Hcommerce,
          isPricingViaToast: action.payload
        }
        }
    case "Item_Add_Ons_Info":
      return{
        ...state, Hcommerce: {
          ...state.Hcommerce,
          itemAddOnsInfo: action.payload
        }
      }
    case "ADDON_GROUP_TYP_ITEM_ADDON_INFO":
      return {
        ...state, Hcommerce: {
          ...state.Hcommerce,
          addOnGroupTypeItemAddonInfo: action.payload
        }
      }
    case "STORE_ITEM_ADDON_GROUP_INFO": {
      return {
        ...state, Hcommerce: {
          ...state.Hcommerce,
          storeItemAddOnGroupInfo: action.payload
        }
      }
    }
    case "ADDON_GROUP_TYPE_INFO": {
      return {
        ...state, Hcommerce: {
          ...state.Hcommerce,
          addOnGroupTypeInfo: action.payload
        }
      }
    }
    case "Store_Item_Store_Upsell_Item_Info":
      return{
        ...state, Hcommerce: {
          ...state.Hcommerce,
          storeItemStoreUpsellItemInfo: action.payload
        }
      }
    case "Sub_Type_Sub_Type_Info":
      return{
        ...state, Hcommerce: {
          ...state.Hcommerce,
          subTypeSubTypeMapping: action.payload
      }
    }
    case "Set_Selected_Sub_Item_List":
      return{
        ...state, Hcommerce: {
          ...state.Hcommerce,
          subItemList: action.payload
        }
      }
    case "set_Selected_Sub_Item_List_Store_Level2":
      return{
        ...state, Hcommerce: {
          ...state.Hcommerce,
          subItemListStoreLevel2: action.payload
        }
      }
    case "Set_Selected_Store_Item_List":
      return{
        ...state, Hcommerce:{
          ...state.Hcommerce,
          selectedStoreItemList: action.payload
        }
      }
    case "Set_Selected_Store_Sub_Menu_List":
      return{
        ...state, Hcommerce:{
          ...state.Hcommerce,
          selectedStoreSubMenuList: action.payload
        }
      }
    case "Set_Selected_SubType_Sub_Menu_List":
      return{
        ...state, Hcommerce:{
          ...state.Hcommerce,
          selectedSubtypeSubMenuList: action.payload
        }
      }
    case "Set_Selected_SubItem_StoreLevel2":
      return{
        ...state, Hcommerce:{
          ...state.Hcommerce,
          selectedSubItemStoreLevel2: action.payload
        }
      }
    case "Item_Sub_Type_List":
      return {
        ...state, Hcommerce: {
          ...state.Hcommerce,
          itemSubTypeList: action.payload
        }
      }
    case "Store_Item_Store_Item_Sub_Type_Info":
      return {
        ...state, Hcommerce: {
          ...state.Hcommerce,
          storeItemStoreItemSubTypeInfo: action.payload
        }
      }
    case "Store_Item_Store_Item_Type_Info":
      return {
        ...state, Hcommerce: {
          ...state.Hcommerce,
          storeItemStoreItemTypeInfo: action.payload
        }
      }
    case "Set_Delivery_Locations":
      return {
        ...state, Hcommerce: {
          ...state.Hcommerce,
          deliveryLocations: action.payload
        }
      }
    case "Store_Item_List":
      return {
        ...state, Hcommerce: {
          ...state.Hcommerce,
          storeItemList: action.payload
        }
      }
    case 'Set_Order_Detail_Page':
      return {
        ...state, Hcommerce: {
          ...state.Hcommerce,
          orderDetailPage: action.payload.status,
          orderDetail: action.payload.orderDetail
        }
      }
    //----------------------------Conform Page--------------------------------

    case 'Set_Conform_Page':
      return {
        ...state, confromPage: action.payload.status,
        conformMessage: action.payload.message,
        compName: action.payload.compName
      }
    case 'Set_TV_Conform_Page':
      return {
        ...state, tvChannels: {
          ...state.tvChannels,
          conformPage: action.payload
        }
      }

    case 'Set_Device_Login_Page':
      return {
        ...state, guestLoginPage: action.payload,
      }

    case 'Set_Chat_Bubble':
      return {
        ...state, showChatBubble: action.payload,
      }
    //-------------------------RoomControl-----------------------------------
    case 'Current_Control_Data':
      return {
        ...state, roomControl: {
          ...state.roomControl,
          currentControl: action.payload
        }
      }
    case 'Set_Speaker_Source_Info':
      return {
        ...state, roomControl: {
          ...state.roomControl,
          speakerList: action.payload.soundBarData
        }
      }
    case 'Set_Song_source':
      return {
        ...state, roomControl: {
          ...state.roomControl,
          selectedSpeaker: {
            ...state.roomControl.selectedSpeaker,
            currentSource: action.payload,
          }
        }
      }
    case 'Set_Speaker_Volume':
      return {
        ...state, roomControl: {
          ...state.roomControl,
          selectedSpeaker: {
            ...state.roomControl.selectedSpeaker,
            currentVolume: action.payload
          }
        }
      }
    case 'Set_Source_For_All_Speaker':
      return {
        ...state, roomControl: {
          ...state.roomControl,
          currentSongSource: action.payload
        }
      }
    case 'Increase_Ac_Temp':
      return {
        ...state, roomControl: {
          ...state.roomControl,
          ACControlStatus: {
            ...state.roomControl.ACControlStatus,
            currentACTemp: action.payload
          }
        }
      }
    case 'Set_Current_Light_Scene':
      return {
        ...state, roomControl: {
          ...state.roomControl,
          currentLightscene: action.payload
        }
      }
    case 'Change_Speaker':
      return {
        ...state, roomControl: {
          ...state.roomControl,
          selectedSpeaker: action.payload
        }
      }
    case 'Set_Fan_Speed':
      return {
        ...state, roomControl: {
          ...state.roomControl,
          currentFanSpeed: action.payload
        }
      }
    case 'Set_Speaker_List':
      return {
        ...state, roomControl: {
          ...state.roomControl,
          speakerList: action.payload
        }
      }
    case 'Set_Speaker_Zone':
      return {
        ...state, roomControl: {
          ...state.roomControl,
          speakerZone: action.payload
        }
      }
    case 'Set_Room_Control_Status':
      //console.log("selectedZone", state.roomControl.selectedZone.zoneId)
      return {
        ...state, roomControl: {
          ...state.roomControl,
          VDAResponse: action.payload.VDAResponse,
          VDAZoneList: action.payload.VDAZoneList,
          selectedZone: state.roomControl.selectedZone.zoneId ?
            state.roomControl.selectedZone : action.payload.selectedZone
        }
      }
    // return {
    //   ...state, roomControl: {
    //     ...state.roomControl,
    //     RoomControlStatus: {
    //       ...state.roomControl.RoomControlStatus,
    //       zone: action.payload.RoomControlStatus
    //     },
    //     currentFanSpeed: action.payload.currentFanSpeed,
    //     lightScreens: action.payload.lightScreens,
    //     powerSwitch: action.payload.powerSwitch,
    //     curatinList: action.payload.curatinList,
    //     celciusMin: action.payload.celciusMin,
    //     celciusMax: action.payload.celciusMax,
    //     doNotDisturb: action.payload.doNotDisturb,
    //     makeUpRoom: action.payload.makeUpRoom,
    //     currentRoomTemp: action.payload.currentRoomTemp,
    //     ecoMode: action.payload.ecoMode
    //   }
    // }
    case 'Set_Power_Switch':
      return {
        ...state, roomControl: {
          ...state.roomControl,
          powerSwitch: action.payload
        }
      }
    case 'Set_Eco_Mode':
      return {
        ...state, roomControl: {
          ...state.roomControl,
          ecoMode: action.payload
        }
      }

    case 'Set_Current_Curtain_Mode':
      return {
        ...state, roomControl: {
          ...state.roomControl,
          currentCurtain: action.payload
        }
      }
    case 'Set_Layout_Type':
      return {
        ...state, layoutType: action.payload
      }
    case 'Set_MakeUPRoom_Mode':
      return {
        ...state, roomControl: {
          ...state.roomControl,
          makeUpRoom: action.payload
        }
      }
    case 'Set_DND_Mode':
      return {
        ...state, roomControl: {
          ...state.roomControl,
          doNotDisturb: action.payload
        }
      }

    case 'Set_Selected_Zone':
      return {
        ...state, roomControl: {
          ...state.roomControl,
          RoomControlStatus: {
            ...state.roomControl.RoomControlStatus,
            zone: action.payload.RoomControlStatus
          },
          selectedZone: action.payload.zone,
          seletedIndex: action.payload.seletedIndex,
          currentFanSpeed: action.payload.currentFanSpeed,
          powerSwitch: action.payload.powerSwitch,
          celciusMin: action.payload.celciusMin,
          celciusMax: action.payload.celciusMax,
          currentRoomTemp: action.payload.currentRoomTemp,
          ecoMode: action.payload.ecoMode
        }
      }
      case 'Set_VDA_RommControl_Data':
        return {
          ...state, VDARoomControl: {
            ...state.VDARoomControl,
            RoomControlData: action.payload.RoomControlData,
            configs: action.payload.configs,
            DND: action.payload.DND,
            MUR: action.payload.MUR,
            hvac: action.payload.hvac,
            lightScene: action.payload.lightScene,
            zoneId: action.payload.zoneId,
            celciusMax: action.payload.celciusMax,
            celciusMin: action.payload.celciusMin,
            farenheitMax: action.payload.farenheitMax,
            farenheitMin: action.payload.farenheitMin
          }
        }
      case 'Set_VDA_Selected_AC':
        return {
          ...state, VDARoomControl: {
            ...state.VDARoomControl,
              selectedAC: action.payload.hvac, 
              selectedIndex: action.payload.selectedIndex,
            currentRoomTemp: action.payload.currentRoomTemp,
            currentFanSpeed: action.payload.currentFanSpeed,
            currentAcTemp: action.payload.currentAcTemp,
            acMode: action.payload.acMode
          }
        }
        case 'Increase_Ac_Temp_VDA':
          return {
            ...state, VDARoomControl: {
              ...state.VDARoomControl,
              currentAcTemp: action.payload
            }
          }
    case 'Set_Inncom_RommControl_Data':
      return {
        ...state, InncomRoomControl: {
          ...state.InncomRoomControl,
          configs: action.payload.configs,
          DND: action.payload.DND,
          MUR: action.payload.MUR,
          hvac: action.payload.hvac,
          lightScene: action.payload.lightScene,
          curtain: action.payload.curtain,
          celciusMax: action.payload.celciusMax,
          celciusMin: action.payload.celciusMin,
          farenheitMax: action.payload.farenheitMax,
          farenheitMin: action.payload.farenheitMin
        }
      }
      case 'Set_Room_Control_Zones_Wise_Data':
      return {
        ...state, RoomControlZonesWiseData: {
          ...state.RoomControlZonesWiseData,
          rooms: action.payload.rooms,
          fanSpeedConfig: action.payload.fanSpeedConfig
        }
      }
      case 'Set_DND_on':
            return {
                ...state, InncomRoomControl: {
                  ...state.InncomRoomControl,
                  DND: action.payload,
                }
            }

        case 'Set_MUR_on':
              return {
                ...state, InncomRoomControl: {
                  ...state.InncomRoomControl,
                MUR: action.payload,
                }                  
            }
    case 'Set_Selected_AC':
      return {
        ...state, InncomRoomControl: {
          ...state.InncomRoomControl,
            selectedAC: action.payload.hvac, 
            selectedIndex: action.payload.selectedIndex,
          currentRoomTemp: action.payload.currentRoomTemp,
          currentFanSpeed: action.payload.currentFanSpeed,
          currentAcTemp: action.payload.currentAcTemp,
          // powerSwitch: hvac.mainSwitch,
          // celciusMin: hvac.celciusMin,
          // celciusMax: hvac.celciusMax,
          acMode: action.payload.acMode
        }
      }
      case 'Increase_Ac_Temp_Inncom':
        return {
          ...state, InncomRoomControl: {
            ...state.InncomRoomControl,
            currentAcTemp: action.payload
          }
        }
    case 'Restore_Zone_Data':
      return {
        ...state, roomControl: {
          ...state.roomControl,
          selectedZone: action.payload.zone,
          seletedIndex: action.payload.seletedIndex,
          VDAZoneList: action.payload.VDAZoneList
        }
      }
    case 'Set_Zone_Count':
      return {
        ...state, roomControl: {
          ...state.roomControl,
          zoneCount: action.payload
        }
      }
    case 'Set_Selected_Control_Zone':
      return {
        ...state, roomControl: {
          ...state.roomControl,
          selectedControlZone: action.payload
        }
      }

    //-------------------health service-----------------
    case 'Guest_Checked_Out':
      return {
        ...state, guestCheckedOut: action.payload,
      }
    //------------------------------- View Bill ------------------------------------------
    case 'Bill_Details':
      return {
        ...state, viewBill: {
          ...state.viewBill,
          billItems: action.payload
        }
      }
    case 'Get_Service_ID':
      return {
        ...state, viewBill: {
          ...state.viewBill,
          extendStayID: action.payload
        }
      }
    case 'View_Bill_Details':
      return {
        ...state, viewBill: {
          ...state.viewBill,
          billItems: action.payload.billItems,
          billTotal: action.payload.billTotal,
          billForGuest: action.payload.billForGuest
        }
      }
    case 'Set_Preload_Screen':
      //console.log("Set_Preload_Screen", action.payload)
      return {
        ...state, preloadScreen: action.payload,
      }

    case 'Set_DoorKey_Notificaion_Page':
      return {
        ...state, doorKey: {
          ...state.doorKey,
          showDoorKeyPage: action.payload
        }
      }
    case 'Set_QR_Scanner_Page':
      return {
        ...state,
        QRScannerPage: action.payload
      }
    case 'Set_Door_Key_Validation_PopUp':
      return {
        ...state, doorKey: {
          ...state.doorKey,
          doorLogin: action.payload
        }
      }
    case 'Set_Call_Native_Methods':
      return {
        ...state, doorKey: {
          ...state.doorKey,
          runNativeCalls: action.payload
        }
      }
    case 'Set_Error_Pop_Door_Key':
      return {
        ...state, doorKey: {
          ...state.doorKey,
          errorPopUP: action.payload
        }
      }

    case 'Set_To_Rescan':
      return {
        ...state, doorKey: {
          ...state.doorKey,
          rescan: action.payload
        }
      }

    case 'Set_Location_Id':
      return {
        ...state, home: {
          ...state.home, guestDetails: {
            ...state.home.guestDetails,
            locationId: action.payload
          }
        }
      }

    case 'Set_GJ_Notifications':
      return{
        ...state,
        home: {
          ...state.home,
          gJnotifications:action.payload
        }
      }

    case 'setCameraPermission':
      return{
        ...state,
        cameraPermissionGranted: action.payload
      }

    case 'Set_Mobile_Overlay_State':
      return{
        ...state,
        mobileOverlayState: action.payload
      }
    case 'Set_FreshChat_Data':
      return{
        ...state,
        freshChatData: action.payload
      }
    case 'Set_Tint_Control_Data':
      return{
        ...state,
        TintControlData: action.payload
      }
    case 'Set_Current_Window':
      return{
        ...state,
        currentWindow: action.payload
      }
    
    case 'TV_CHANNEL_MIN_VIEW_DURATION':
      return{
        ...state,
        minimumChannelWatchDuration: action.payload
      }

    case "Set_Disable_Order_Popup":
      return {
        ...state,
        showDisableOrderPopup: action.payload
      }
    case "Reset_Hcommerce":
      console.log("hcommerce is resetting", action.payload)
      return{
        ...state, Hcommerce: {
          ...state.Hcommerce,
          storeItemTypeSubTypeInfo: action.payload,
          itemTypeList: action.payload,
          upsellItem: action.payload,
          storeInfo: action.payload,
          itemAddOnsInfo: action.payload,
          addOnGroupTypeItemAddonInfo: action.payload,
          storeItemAddOnGroupInfo: action.payload,
          addOnGroupTypeInfo: action.payload,
          storeItemStoreUpsellItemInfo: action.payload,
          itemSubTypeList: action.payload,
          storeItemStoreItemSubTypeInfo: action.payload,
          storeItemStoreItemTypeInfo: action.payload,
          deliveryLocations: action.payload,
          storeItemList: action.payload
        }
      }
    case 'Set_Fail_Screen':
      return{
        ...state, failScreenconfig: {
          ...state.failScreenconfig,
          showFailScreen: action.payload.showFailScreen,
          failScreenMessage1: action.payload.failScreenMessage1,
          failScreenMessage2: action.payload.failScreenMessage2,
          showClose: action.payload.showClose,
        }
      }
    case "Set_Guest_Login":
      return{
        ...state,
        showGuestLogin: action.payload
      }
    case "Set_guest_doc_options":
      return{
        ...state,
        guestDocOptions: action.payload
      }
    case "Set_Survey_Data":
      return{
        ...state,
        survey: action.payload
      }
    case "Set_TV_Lift_Data":
      return{
        ...state,
        tVLiftList: action.payload
      }
    case "Set_Show_TV_Lift":
      return {
        ...state,
        showTVLiftWidget: action.payload
      }
    case "Set_LEA_Spaeker_Data":
      console.log("props.speakerList", action.payload)
      return {
        ...state,
        leaSpeakerData: action.payload
      }
    case "Set_Selected_Master_Device":
      return{
        ...state,
        selectedMasterDevice: action.payload
      }
    case "Set_Speaker_In_Zone":
      return{
        ...state,
        speakerInZone: action.payload
      }
    case "Set_Login_Required":
      return{
        ...state,
        showLoginRequired: action.payload.showLoginRequired,
        loginRequiredMessage: action.payload.loginRequiredMessage
      }  
      case "Set_Custom_Text_For_Login_Popup":
        return{
          ...state,
          customTextForLoginPopup: action.payload.customTextForLoginPopup
           
        }
    case "Set_Warning_Popup":
      return{
        ...state,
        showWarningPopup: {
          ...state.showWarningPopup,
          show: action.payload.show,
          msg: action.payload.msg
        }
      }
    case "Set_Current_Window_Tint_Page":
      return {
        ...state,
        currentTintWindow: action.payload
      }
    case "Set_Current_Zone_Step":
      return {
        ...state,
        currentZoneStep: action.payload
      }
    case "Set_Selected_Windows":
      return {
        ...state,
        selectedWindows: action.payload
      }
    case "Set_Selected_Tint_Level":
      return {
        ...state,
        selectedTintLevel: action.payload
      }
    default:
      return state;
  }
}